<template>
    <div class="modal fade text-left" id="gallery-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1"
         aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-3 right-border">
                            <div class="folders" v-show="showUploadTab">
                                <div class="folders--header"><h4>Folders</h4> <a href="#" title="add folder"
                                                                                 @click="addFolderShow = !addFolderShow; selectedFolder = null"><i
                                    class="feather icon-plus"></i></a></div>
                                <div class="folders--body">
                                    <div class="folder" v-if="addFolderShow"><span class="folder--icon"></span> <span
                                        class="folder--name"> <input @keyup.enter="addFolder"
                                                                     v-model="folder.folder_name"
                                                                     placeholder="Folder Name"/> </span></div>
                                    <div class="folder" @click="folderClickHandler('all')">
                                        <i class="feather icon-folder"></i>
                                        </span> <span class="folder--name">All</span> <span
                                        class="folder--item-count">{{ defaultImages.length }}</span> <i
                                        class="feather"></i></div>
                                    <div class="folder" @click="folderClickHandler(undefined)">
                                        <i class="feather icon-folder"></i><span
                                        class="folder--name">Uncategorized</span>
                                        <span class="folder--item-count">{{ uncategorized.length }}</span> <i
                                        class="feather"></i></div>
                                    <div v-for="folder in folders" :key="folder.id">
                                        <div class="folder" @click="folderClickHandler(folder)"
                                             @contextmenu.prevent.stop="showMenu(folder, $event)">
                                            <i class="feather icon-folder"></i><span
                                            class="folder--name">{{ folder.folder_name }}</span> <span
                                            class="folder--item-count">{{
                                                (folder.subfolders ? folder.subfolders.length : 0) + folder.galleries.length
                                            }}</span>
                                            <i class="feather" :class="{'icon-chevron-right': folder.subfolders}"></i>
                                        </div>
                                        <div class="folder sub-folder" @click="folderClickHandler(subfolder)"
                                             v-for="subfolder in folder.subfolders" :key="subfolder.id"
                                             @contextmenu.prevent.stop="showMenu(subfolder, $event)"><span
                                            class="folder--icon"></span> <span
                                            class="folder--name">{{ subfolder.folder_name }}</span> <span
                                            class="folder--item-count">{{ folder.galleries.length }}</span> <i
                                            class="feather"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9 left-border"><h4>{{ galleryHeader }}</h4>
                            <ul class="nav nav-tabs mb-2" role="tablist">
                                <li class="nav-item" @click="showUploadTab = false"><a
                                    class="nav-link d-flex align-items-center" id="upload-tab" data-toggle="tab"
                                    href="#upload" aria-controls="upload" role="tab" aria-selected="true"> <i
                                    class="feather icon-user mr-25"></i><span
                                    class="d-none d-sm-block">Upload Files</span> </a></li>
                                <li class="nav-item" @click="showUploadTab = true"><a
                                    class="nav-link d-flex align-items-center active" id="library-tab" data-toggle="tab"
                                    href="#library" aria-controls="library" role="tab" aria-selected="false"> <i
                                    class="feather icon-info mr-25"></i><span
                                    class="d-none d-sm-block">Media Library</span> </a></li>
                            </ul>
                            <div class="tab-content gallery-content">
                                <div class="tab-pane" id="upload" aria-labelledby="account-tab" role="tabpanel">
                                    <form action="">
                                        <file-pond name="test" ref="pond" label-idle="Drop files here..."
                                                   :allow-multiple="true" accepted-file-types="image/jpeg, image/png"
                                                   :files="images" :init="handleFilePondInit"/>
                                        <select name="" id="" v-model="selectedFolder">
                                            <option value="">Select Folder</option>
                                            <option v-for="folder in allFolders" :key="folder.id" :value="folder.id">
                                                {{ folder.folder_name }}
                                            </option>
                                        </select>
                                        <button class="btn btn-primary btn-sm" type="button" @click="addImage">Submit
                                        </button>
                                    </form>
                                </div>
                                <div class="tab-pane active" id="library" aria-labelledby="account-tab" role="tabpanel">
                                    <div class="gall" :class="{'my-gallery': !galleryHeader}" itemscope=""
                                         itemtype="http://schema.org/ImageGallery" data-pswp-uid="1">
                                        <div class="row">
                                            <figure class="col-lg-3 col-md-6 col-12" itemprop="associatedMedia"
                                                    itemscope="" itemtype="http://schema.org/ImageObject"
                                                    v-for="image in allImages" :key="image.id">
                                                <a :href="image.image" itemprop="contentUrl"
                                                   :data-size="image.dimension" v-if="!galleryHeader">
                                                    <img class="img-thumbnail img-fluid" :src="image.image_thumbnail"
                                                         itemprop="thumbnail" alt="Image description">
                                                </a>
                                                <img
                                                    class="img-thumbnail img-fluid" :src="image.image_thumbnail"
                                                    :class="{'selected-image': multipleImages ? selectedImage.indexOf(image.id) !== -1 : selectedImage===image.id }"
                                                    itemprop="thumbnail" alt="Image description" v-else
                                                    @click="addImageToSelectedImage(image.id)"></figure>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn grey btn-outline-secondary"
                                                data-dismiss="modal">Close
                                        </button>
                                        <button type="button" class="btn btn-outline-primary" v-if="galleryHeader"
                                                :disabled="!selectedImage" @click="pushImage">Add Image
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-click-outside="closeMenu" class="context-menu" v-if="toggleMenu"
             :style="{'top': mouseCoords.clientY + 'px', 'left': mouseCoords.clientX + 'px'}">
            <ul>
                <li @click="addFolderShow = true; toggleMenu = false" v-if="!selectedFolder.is_sub_folder"><i
                    class="feather icon-folder-plus"></i> New Folder
                </li>
                <li><i class="feather icon-file-text"></i> Rename</li>
                <li><i class="feather icon-delete"></i> Delete</li>
            </ul>
        </div>
    </div>
</template>
<script>
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import axios from 'axios';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)
export default {
    name: "GalleryModal",
    props: ['galleryHeader', 'multipleImages'],
    components: {FilePond},
    data: () => ({
        images: [],
        category: '',
        addFolderShow: false,
        folder: {},
        folders: [],
        allFolders: [],
        selectedFolder: "",
        mouseCoords: {clientX: 0, clientY: 0},
        toggleMenu: false,
        allImages: [],
        uncategorized: [],
        defaultImages: [],
        showUploadTab: true,
        selectedImage: [],
    }),
    async created() {
        try {
            const {
                data: {
                    folders,
                    all_images: allImages,
                    all_folders: allFolders
                }
            } = await axios.get(route('admin.galleries.index'), {
                params: {
                    api: true,
                },
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
            });
            this.folders = folders;
            this.allImages = allImages;
            this.allFolders = allFolders;
            this.defaultImages = this.allImages;
            this.uncategorized = this.allImages.filter(image => !image.gallery_folder_id);
        } catch (e) {
            console.log(e);
        }
    },
    methods: {

        addImageToSelectedImage(id) {

            if (this.multipleImages) {
                let index = this.selectedImage.indexOf(id);

                if (index !== -1) {
                    this.selectedImage.splice(index, 1);
                } else {
                    this.selectedImage.push(id);
                }
            } else {
                this.selectedImage = id;
            }

        },
        pushImage() {
            let selectedImage = this.selectedImage
            if (this.multipleImages) {
                this.$emit('chooseImage', this.allImages.filter(function (image) {
                    return selectedImage.includes(image.id);
                }));
            } else {
                this.$emit('chooseImage', this.allImages.find((image) => image.id === selectedImage));
            }

            $('#gallery-modal').modal('hide');
        },
        async addFolder() {
            let folderData = this.folder;
            if (this.selectedFolder) {
                folderData.is_sub_folder = 1;
                folderData.top_folder_id = this.selectedFolder.id;
            }

            try {
                const {
                    data: {
                        data,
                        message,
                        folder
                    }
                } = await axios.post(route('admin.galleries.create-folder'), folderData);
                this.folder = {};
                this.addFolderShow = false;
                this.selectedFolder = null;
                this.folders = data;
                this.allFolders.push(folder);
                alert('Folder Created!')
            } catch (e) {
                alert('Folder not Created, try again')
            }
        },
        showMenu(folder, event) {
            this.toggleMenu = true;
            this.selectedFolder = folder;
            this.mouseCoords.clientX = event.clientX;
            this.mouseCoords.clientY = event.clientY - 70;
        },
        folderClickHandler(folder) {
            console.log(folder)
            if (folder === undefined) {
                this.allImages = this.uncategorized;
                return;
            } else if (folder === 'all') {
                this.allImages = this.defaultImages;
                return;
            }
            this.selectedFolder = folder;
            this.allImages = folder.galleries;
        },
        async addImage() {
            const uploadedFiles = this.$refs.pond.getFiles();
            if (uploadedFiles.length > 0) {
                const formData = new FormData();
                uploadedFiles.forEach(upf => formData.append('images[]', upf.file));
                formData.append('folder_id', this.selectedFolder ? (this.selectedFolder.id ? this.selectedFolder.id : this.selectedFolder) : '');
                try {
                    await axios.post(route('admin.galleries.store'), formData);
                    location.reload();
                } catch (e) {
                    console.log(e);
                }
            }
        },
        handleFilePondInit: function () {
            console.log('FilePond has initialized');
            // FilePond instance methods are available on `this.$refs.pond`
        }, closeMenu() {
            this.toggleMenu = false;
            this.selectedFolder = {};
        }
    },
} </script>

<style scoped lang="scss">
.right-border, .left-border {
    height: 87vh;
}

.left-border {
    .gall {
        overflow-x: hidden;
        overflow-y: auto;
        height: 70vh;
    }
}

.img-thumbnail {
    cursor: pointer;
}

.selected-image {
    border: 2px solid blue;
}

.gallery-content {
    overflow-y: scroll;
    height: calc(100% - 90px);
}

.right-border {
    border-right: 1px solid #ccc;
}

.folder--name {
    flex: 1;
    font-weight: 600;
    text-transform: capitalize;
}

.folder {
    margin: 7px 0;
    display: flex;
    cursor: pointer;
    align-items: center;
}

.folder--name {
    flex: 1;
    font-weight: 600;
    text-transform: capitalize;
}
</style>
